
import moment from 'moment';

export default {
	loggedIn: ['User', function (User) {
		return User.requireLogin();
	}],
	zones: ['loggedIn', 'Zone', function (loggedIn, Zone) {
		return Zone.all();
	}],
	stores: ['zones', '$filter', function (zones, $filter) {
		return generateStores(zones, $filter('translate'));
	}],
	selectedStore: ['stores', '$stateParams', 'Session', function (stores, $stateParams, Session) {
		const selectedStore = $stateParams.stores
			|| Session.get('selected-store')
			|| 'all';
		Session.set('selected-store', selectedStore);
		return stores.filter(s => s.id === selectedStore)[0] || stores[0];
	}],
	endDate: ['$stateParams', 'Session', function ($stateParams, Session) {
		const endDate = $stateParams.endDate
			|| Session.get('end-date')
			|| moment().endOf('week').subtract(1, 'w').format('YYYY-MM-DD');
		Session.set('end-date', endDate);
		return endDate;
	}],
	startDate: ['$stateParams', 'Session', function ($stateParams, Session) {
		const startDate = $stateParams.startDate
			|| Session.get('start-date')
			|| moment().startOf('week').subtract(1, 'w').format('YYYY-MM-DD');
		Session.set('start-date', startDate);
		return startDate;
	}],
};


/*
 * Helpers
 */
function generateStores (zones, translate) {
	var stores = [];
	var all = [];

	zones.forEach(zone => {
		var storeIds = zone.stores.map(store => store.id);

		stores.push({
			id:         'zone-'+zone.id,
			name:       translate('ZONE')+' '+zone.description,
			selectName: translate('ZONE')+' '+zone.description,
			storeIds:   storeIds,
		});

		stores = stores.concat(zone.stores.map(store => ({
			id:         'store-'+store.id,
			name:       store.name,
			selectName: ' - '+store.name+' ('+store.trueId+')',
			storeIds:   [ store.id ],
		})));

		all = all.concat(storeIds)
	});

	stores.unshift({
		id:         'all',
		name:       translate('ALL_STORES'),
		selectName: translate('ALL_STORES'),
		storeIds:   all,
	});

	return stores;
}



// WEBPACK FOOTER //
// ./src/directive/store-date-selector/store-date-selector.resolve.js